// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3phNR","savePackageButton":"ClientWallet_savePackageButton__2yBNf"};